import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TaxesListComponent } from './taxes-list/taxes-list.component';
import { TaxesDetailComponent } from './taxes-detail/taxes-detail.component';

const routes: Routes = [
    {
        path: 'taxes',
        children: [
            { path: '', component: TaxesListComponent }
        ]
    },
    {
        path: 'taxes/:id',
        children: [
            { path: '', component: TaxesDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TaxesRoutingModule { }
